export const StreamProcessorName = "audio-player";
const StreamProcessorWorklet = `
"use strict";

/* ----------  AudioPlayerProcessor  ---------- */
class AudioPlayerProcessor extends AudioWorkletProcessor {
    constructor() {
        super();
        this.initBufferStore();
        this.state = "idle";   // idle | playing | paused
        this.currentTime = 0;
        this.lastEmit = 0;
        this.totalSamplesEmitted = 0;

        /* ---- messages from main thread ---- */
        this.port.onmessage = (ev) => {
            const { audioData, play, pause, clear } = ev.data;

            if (audioData) {
                this.writeData(audioData);
            }

            if (play && this.state !== "playing") {
                this.state = this.outputBuffers.length ? "playing" : "idle";
                this.port.postMessage({ state: this.state });
            }

            if (pause && this.state === "playing") {
                this.state = "paused";
                this.port.postMessage({ state: "paused" });
            }

            if (clear) {
                this.initBufferStore();
                this.currentTime = 0;
                this.state = "idle";
                this.port.postMessage({ state: "idle", currentTime: 0 });
            }
        };
    }

    /**
     * Initializes the buffer store for audio data.
     * This sets up the initial buffer length and prepares the output buffers.
     */
    initBufferStore() {
        this.bufferLength = 128;
        this.outputBuffers = [];
        this.writeBuffer = new Float32Array(this.bufferLength);
        this.writeOffset = 0;
    }

    /**
     * Writes audio data to the output buffers.
     * @param {ArrayBuffer} audioData - The audio data to write.
     */
    writeData(audioData) {
        const int16Data = new Int16Array(audioData);
        const floatData = new Float32Array(int16Data.length);

        // Convert from Int16 to Float32 (-1.0 to 1.0)
        for (let i = 0; i < floatData.length; i++) {
            floatData[i] = int16Data[i] / 0x8000; // Convert Int16 to Float32
        }

        for (let i = 0; i < floatData.length; i++) {
            this.writeBuffer[this.writeOffset++] = floatData[i];
            if (this.writeOffset >= this.bufferLength) {
                this.writeBuffer = new Float32Array(this.bufferLength);
                this.outputBuffers.push(this.writeBuffer);
                this.writeOffset = 0;
            }
        }
    }

    /**
     * Read audio data from the output buffers.
     * @param {number} length - The number of samples to read.
     * @returns {Float32Array} - The read audio data.
     */
    readData(length) {
        if (this.outputBuffers.length === 0) {
            throw new Error("No audio data available to read.");
        }
        let output = new Float32Array(length);
        const buffer = this.outputBuffers.shift();
        for (let sampleNum = 0; sampleNum < length; sampleNum++) {
            output[sampleNum] = buffer[sampleNum] || 0;
        }

        return output;
    }

    process(_ins, outs) {
        const chan = outs[0][0];
        if (this.state !== "playing") return true;

        if (this.outputBuffers.length) {
            const samples = this.readData(chan.length);
            chan.set(samples);
            this.currentTime += samples.length / sampleRate;
            this.totalSamplesEmitted += samples.length;

            if (this.state === "idle") {
                this.state = "playing";
                this.port.postMessage({ state: "playing", currentTime: this.currentTime });
            } else if (this.outputBuffers.length === 0) {
                let a = 1;
                // this.state = "idle";
                // this.currentTime = 0;
                // this.port.postMessage({ state: "idle", currentTime: 0 });
            } else if (this.currentTime - this.lastEmit > 0.5) {
                this.lastEmit = this.currentTime;
                this.port.postMessage({ currentTime: this.currentTime });
            }
        }

        return true;
    }
}

registerProcessor("${StreamProcessorName}", AudioPlayerProcessor);
`

const script = new Blob([StreamProcessorWorklet], {
  type: 'application/javascript',
});
const src = URL.createObjectURL(script);
export const StreamProcessorSrc = src;